import React from 'react';
import './GlassCard.scss';

interface GlassCardProps {
  children: React.ReactNode | React.ReactNode[];
  isGlassOnly?: boolean;
}

const GlassCard = ({ children, isGlassOnly = false }: GlassCardProps) => {
  if (isGlassOnly) {
    return <div className="glass-only-container">{children}</div>;
  }

  return (
    <div className="glass-container">
      <div className="content">{children}</div>
    </div>
  );
};

export default GlassCard;
